const Stories : React.FC = () =>{
    return(
        <p>Here are our success stories</p>
    )
} 
export default Stories;